import React from "react";
import { Divider, Flex, Button, Form, Input, message, Radio, InputNumber, Alert } from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import Captcha from "../../components/captcha";

const Regist = () => {
    const [form] = Form.useForm();
    const [imageUrl, setImageUrl] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [actionUrl, setActionUrl] = React.useState();
    const phoneNo = Form.useWatch('phoneNo', form);

    const onSubmit = async () => {
        try {
            const url = new URL(window.location.href);
            const values = await form.validateFields();

            let response = await fetch(`/api/login/reset${url.search}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            });

            let result = await response.json();

            if (result && result.success) {
                // message.success("注册成功！");
                setTimeout(() => {
                    window.location.href = `/login`;
                }, 500);
            } else {
                message.error(result.data);
            }

        } catch (errorInfo) {
            console.log("Failed:", errorInfo);
        }
    };

    return (
        <div>
            <Form form={form} style={{ maxWidth: "600px", margin: "0 auto" }}>
                
                <h2 style={{textAlign: 'center'}}>重置密码</h2>
                <Alert message="新密码将通过短信发送给您，请注意查收。" type="info" showIcon style={{margin: '0 0 20px 0'}} />
                <Form.Item
                    label="手机号码"
                    name="phoneNo"
                    rules={[{ required: true, message: "请输入手机号码" }, { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码" }]}
                >
                    <InputNumber min={1} maxLength={11} style={{ width: "100%" }} placeholder="请输入手机号码" />
                </Form.Item>

                <Form.Item
                    label="短信验证码"
                    name="code"
                    rules={[{ required: true, message: "请输入验证码" }]}
                >
                    <Captcha 
                      phoneNo={phoneNo} 
                      onSendCode={() => {
                        // 可以在这里添加额外的处理逻辑
                        console.log("验证码已发送");
                      }}
                    />
                </Form.Item>

                <Divider />
                <Flex gap={20} justify="center">
                    <Button type="default" href="/login">
                        返回登录
                    </Button>
                    <Button type="primary" onClick={onSubmit}>
                        重置
                    </Button>
                </Flex>
            </Form>
        </div>
        
    );    
};

export default Regist;